import { Component, OnInit,Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material'; 
// import {MatBottomSheet} from '@angular/material';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.css']
})
export class SnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) { }

  clearBar(): void {
    this.snackBarRef.dismiss();
    event.preventDefault();
  }

}



// WEBPACK FOOTER //
// ./src/app/snackbar/snackbar.component.ts